<script setup lang="ts">
import { computed, ref } from 'vue';
import { Session } from '../../../types/session';
import { LectureView } from '../../../types/lecture';
import TeacherLectureVideo from './TeacherLectureVideo.vue';
import Button from '../../General/Button.vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../configs/text';
import TeacherLectureQuestion from './TeacherLectureQuestion.vue';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/vue/24/solid';
import { useClassStore, useSessionStore } from '../../../stores';
import { AssessmentQuestion } from '../../../types/assessment';
import Fullscreen from '../../General/Fullscreen.vue';

const classStore = useClassStore()
const sessionStore = useSessionStore()
const iclassQuestions = computed<AssessmentQuestion[] | undefined>(() => sessionStore.classContent?.[Session.lecture].questions)

const view = ref<LectureView>(LectureView.video)
const submissionsCount = computed<number>(() => {
    return classStore.selectedClassDetails?.students?.filter(student => student.isSubmitLecture).length || 0
})

const wrapperComponent = computed(() => {
    return view.value === LectureView.question ? Fullscreen : 'div'
})

function toggleView() {
    if (view.value === LectureView.question) {
        view.value = LectureView.video
        return;
    }

    view.value = LectureView.question
}

const { t } = useI18n()
</script>

<template>
    <component :is="wrapperComponent" class="p-3 h-full flex flex-col gap-3 items-center">
        <template v-if="view === LectureView.question">
            <div class="grid grid-cols-2 md:grid-cols-3 gap-3 w-full">
                <div class="flex items-center cursor-pointer text-sky-400 font-bold mr-auto" @click="toggleView">
                    <ChevronLeftIcon class="h-6" />
                    <span class="whitespace-pre">{{ t(TEXT.video) }}</span>
                </div>
                <div v-if="iclassQuestions?.length" class="text-center">
                    <Button :shadow="false" :border="false" size="small"
                        class="px-6 ml-auto md:mx-auto font-normal cursor-auto hover:!bg-orange-600 focus:!bg-orange-600">
                        {{ t(TEXT.submission) }}: {{ `${submissionsCount}/${classStore.attendedStudentCount}` }}
                    </Button>
                </div>
            </div>

            <TeacherLectureQuestion />
        </template>

        <template v-if="view === LectureView.video">
            <div class="flex items-center cursor-pointer text-sky-400 font-bold ml-auto" @click="toggleView">
                <span class="whitespace-pre">{{ t(TEXT.question_list) }}</span>
                <ChevronRightIcon class="h-6" />
            </div>

            <TeacherLectureVideo />
        </template>
    </component>
</template>